/* Liste déroulante Layers : remplace l'affichage d'un <select data-lm-select> par un bouton + liste stylés.
   Le <select> d'origine reste dans le formulaire (c'est lui qui est envoyé). Sur écran tactile, on garde le sélecteur natif du téléphone. */
(function () {
  if (window.__lmSelect) return; window.__lmSelect = true;
  var touch = window.matchMedia('(pointer: coarse)').matches;
  var uid = 0;

  function enhance(select) {
    if (select.__lm) return; select.__lm = true;
    var wrap = document.createElement('div');
    wrap.className = 'lm-select';
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    var chevron = document.createElement('span');
    chevron.className = 'lm-select__chevron'; chevron.setAttribute('aria-hidden', 'true');
    chevron.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
    wrap.appendChild(chevron);
    var syncEmpty = function () { wrap.classList.toggle('is-empty', !select.value); };
    select.addEventListener('change', syncEmpty); syncEmpty();
    if (touch) { wrap.classList.add('lm-select--native'); return; }

    var id = 'lm-select-' + (++uid);
    var label = select.getAttribute('aria-label') || (select.labels && select.labels[0] && select.labels[0].textContent) || '';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'lm-select__button';
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', id);
    if (label) btn.setAttribute('aria-label', label);
    var value = document.createElement('span'); value.className = 'lm-select__value'; btn.appendChild(value);
    var list = document.createElement('ul');
    list.className = 'lm-select__list'; list.id = id; list.setAttribute('role', 'listbox'); list.tabIndex = -1; list.hidden = true;
    if (label) list.setAttribute('aria-label', label);
    wrap.insertBefore(btn, chevron); wrap.appendChild(list);
    select.tabIndex = -1; select.setAttribute('aria-hidden', 'true'); wrap.classList.add('lm-select--custom');

    var opts = Array.prototype.filter.call(select.options, function (o) { return !(o.disabled && o.value === ''); });
    var placeholder = Array.prototype.find.call(select.options, function (o) { return o.value === ''; });
    var items = opts.map(function (o, i) {
      var li = document.createElement('li');
      li.id = id + '-o' + i; li.className = 'lm-select__option'; li.setAttribute('role', 'option');
      li.textContent = o.textContent; li.dataset.value = o.value;
      if (o.disabled) li.setAttribute('aria-disabled', 'true');
      li.addEventListener('click', function () { if (!o.disabled) { choose(i); close(true); } });
      li.addEventListener('mousemove', function () { if (active !== i) setActive(i); });
      list.appendChild(li); return li;
    });
    var active = -1, typed = '', typedTimer;

    function render() {
      var cur = opts.indexOf(select.options[select.selectedIndex]);
      value.textContent = cur >= 0 ? opts[cur].textContent : (placeholder ? placeholder.textContent : '');
      items.forEach(function (li, i) { li.setAttribute('aria-selected', i === cur ? 'true' : 'false'); });
      syncEmpty();
    }
    function setActive(i) {
      if (active >= 0) items[active].classList.remove('is-active');
      active = i;
      if (i >= 0) { items[i].classList.add('is-active'); list.setAttribute('aria-activedescendant', items[i].id); items[i].scrollIntoView({ block: 'nearest' }); }
    }
    function choose(i) {
      if (opts[i].disabled) return;
      select.value = opts[i].value; render();
      select.dispatchEvent(new Event('input', { bubbles: true })); select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function open() {
      if (!list.hidden) return;
      list.hidden = false; wrap.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
      var r = btn.getBoundingClientRect();
      wrap.classList.toggle('is-up', window.innerHeight - r.bottom < Math.min(list.scrollHeight, 280) + 16 && r.top > window.innerHeight - r.bottom);
      setActive(Math.max(0, opts.indexOf(select.options[select.selectedIndex])));
      list.focus({ preventScroll: true });
      document.addEventListener('pointerdown', outside, true);
    }
    function close(focusBtn) {
      if (list.hidden) return;
      list.hidden = true; wrap.classList.remove('is-open', 'is-up'); btn.setAttribute('aria-expanded', 'false'); setActive(-1);
      document.removeEventListener('pointerdown', outside, true);
      if (focusBtn) btn.focus();
    }
    function outside(e) { if (!wrap.contains(e.target)) close(false); }
    function move(d) { var i = active; for (var n = 0; n < items.length; n++) { i = (i + d + items.length) % items.length; if (!opts[i].disabled) { setActive(i); return; } } }

    btn.addEventListener('click', function () { list.hidden ? open() : close(true); });
    btn.addEventListener('keydown', function (e) {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) > -1) { e.preventDefault(); open(); if (e.key === 'ArrowUp') move(-1); }
    });
    list.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Home') { e.preventDefault(); setActive(0); }
      else if (e.key === 'End') { e.preventDefault(); setActive(items.length - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (active >= 0) choose(active); close(true); }
      else if (e.key === 'Escape') { e.preventDefault(); close(true); }
      else if (e.key === 'Tab') { close(false); }
      else if (e.key.length === 1) {
        clearTimeout(typedTimer); typed += e.key.toLowerCase(); typedTimer = setTimeout(function () { typed = ''; }, 600);
        for (var i = 0; i < items.length; i++) if (items[i].textContent.toLowerCase().indexOf(typed) === 0) { setActive(i); break; }
      }
    });
    select.addEventListener('change', render);
    select.form && select.form.addEventListener('reset', function () { setTimeout(render, 0); });
    /* validation native : renvoyer le focus sur le bouton visible */
    select.addEventListener('invalid', function () { wrap.classList.add('is-invalid'); btn.focus(); });
    select.addEventListener('change', function () { wrap.classList.remove('is-invalid'); });
    render();
  }

  function init(root) { Array.prototype.forEach.call((root || document).querySelectorAll('select[data-lm-select]'), enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
